// import devtools from "@vue/devtools";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueLocalStorage from "vue-localstorage";
import moment from "moment";
import VueMoment from "vue-moment";
import UUID from "vue-uuid";
// import money from "v-money";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import Element from "element-ui";
import i18n from "@/locales";
import VueCurrencyInput from "vue-currency-input";
import VueShortKey from "vue-shortkey";
import DlgDraggable from "vue-element-dialog-draggable";
import VueAppend from "vue-append";

import "element-ui/lib/theme-chalk/reset.css";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/theme-catherine/element-ui-overwrite.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

Vue.config.productionTip = false;

const locale = i18n.locale === "ua" ? "uk" : i18n.locale;
moment.locale(locale);

Vue.use(VueAxios, axios);
Vue.use(VueLocalStorage);
Vue.use(VueMoment, { moment });
Vue.use(UUID);
// Vue.use(money, { precision: 2 });

Vue.use(Element, {
  size: "medium",
  zIndex: 3000,
  i18n: (key, value) => i18n.t(key, value)
});

const pluginOptions = {
  globalOptions: { currency: null }
};
Vue.use(VueCurrencyInput, pluginOptions);

Vue.use(VueShortKey, { prevent: ["el-input", "input", "textarea"] });

Vue.use(DlgDraggable, {
  containment: false
});

Vue.use(VueAppend);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
